<template>
  <div style="margin:0 8px">
    <el-row style="height:50px;padding-top:14px" :class="newsName">
      <el-col :span="18" class="news-title">
        <span>
          <img src="../assets/images/newsTitle.png" alt="" style="position:absolute;left:10px;top:50%;transform:translateY(-50%)" /> {{ title }}
        </span>
      </el-col>
      <el-col :span="6" style="text-align:right;color:#999;font-size:14px;padding-right:8px">
        <span @click="gotoLieBiao(path)" style="cursor:pointer">>>
          <span style="color:#1A73E7">更多</span>
        </span>
      </el-col>
    </el-row>
    <el-row>
      <div style="height:124px;margin:10px 0;display:flex;justify-content:space-between" v-if="(title==='教学培训' && newsContent[0].imgSrcJxxx) || (title==='文化交流' && newsContent[1].imgSrcWhjl)">
        <!-- 缩略图区域 -->
        <img v-if="title==='教学培训'" :class="columnCode" :src="newsContent[0].imgSrcJxxx"/>
        <img v-if="title==='文化交流'" :class="columnCode" :src="newsContent[1].imgSrcWhjl"/>
        <!-- <img v-if="title==='本院新闻'" :class="columnCode" :src="newsContent[2].imgSrcSyxw"/> -->
        <!-- 列表区域 -->
        <div class="fd-news-right" v-if="title==='教学培训'" @click="gotoDetails(newsContent[0])">
          <h3>{{newsContent[0].title}}</h3>
          <div v-html="newsContent[0].content"  class="content"></div>
        </div>
        <div class="fd-news-right" v-if="title==='文化交流'" @click="gotoDetails(newsContent[1])">
          <h3>{{newsContent[1].title}}</h3>
          <div v-html="newsContent[1].content" :title="newsContent[1].content" class="content"></div>
        </div>
        <div class="fd-news-right" v-if="title==='央院新闻'" @click="gotoDetails(newsContent[2])">
          <h3>{{newsContent[2].title}}</h3>
          <div v-html="newsContent[2].content" class="content"></div>
        </div>
        <div class="fd-news-right" v-if="title==='本院新闻'" @click="gotoDetails(newsContent[2])">
          <h3>{{newsContent[2].title}}</h3>
          <div v-html="newsContent[2].content" class="content"></div>
        </div>
      </div>
      <el-table :data="tableData" :show-header="false" style="width: 100%" @row-click="gotoDetails" row-class-name="rowClass">
        <el-table-column prop="title" min-width="160px" :show-overflow-tooltip="false">
          <template slot-scope="scope">
            <div style="float:left;width:4px;height:4px;line-height:4px;background:#D8D8D8;border-radius:50%;display:inline-block;margin-bottom:2px;margin-right:6px;margin-top:10px"> </div>
            <span :title="scope.row.title" class="fd-rowTiltle">{{ scope.row.title }}</span>
            <!--首页新闻标题-->
          </template>
        </el-table-column>
        <el-table-column align="right" width="120px" prop="publishDate"> </el-table-column>
      </el-table>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      patht:''
      // newsName: 'tzyw'
    };
  },
  props: {
    newsContent: {
      type: Array,
    },
    title: {
      type: String,
    },
    columnCode: {
      type: String,
    },
    tableData: {
      type: Array,
    },
    menuList: {
      type: Array,
    },
    path: {
      type: String,
    },
    newsName: {
      type: String,
    },
  },
  methods: {
    gotoDetails(row) {
      this.patht=this.path
      if(this.path=='/yjdt/czdjsyjzx/zxgk'){
        if(row.columnCode=='SYZT_CZDJSYJZX_ZXXX'){
          this.patht='/yjdt/czdjsyjzx/zxxx'
        }else if(row.columnCode=='SYZT_CZDJSYJZX_CZDWX'){
          this.patht='/yjdt/czdjsyjzx/czdyjwx'
        }else if(row.columnCode=='SYZT_CZDJSYJZX_YJZL'){
          this.patht='/yjdt/czdjsyjzx/qtyjzl'
        }else if(row.columnCode=='SYZT_CZDJSYJZX_ALK'){
          this.patht='/yjdt/czdjsyjzx/alk'
        }else if(row.columnCode=='SYZT_FGYZJJZX_ZXXX'){
          this.patht='/yjdt/fgyzjjzx/zxxx'
        }else if(row.columnCode=='SYZT_FGYZJJZX_YJZL'){
          this.patht='/yjdt/fgyzjjzx/yjzl'
        }else if(row.columnCode=='SYZT_FGYZJJZX_ALK'){
          this.patht='/yjdt/fgyzjjzx/alk'
        }else if(row.columnCode=='SYZT_MZYZJYJZX_ZXXX'){
          this.patht='/yjdt/mzyzjzx/zxxx'
        }else if(row.columnCode=='SYZT_MZYZJYJZX_YJZL'){
          this.patht='/yjdt/mzyzjzx/yjzl'
        }else if(row.columnCode=='SYZT_MZYZJYJZX_ALK'){
          this.patht='/yjdt/mzyzjzx/alk'
        }else if(row.columnCode=='SYZT_ZHWHYJZX_ZXXX'){
          this.patht='/yjdt/zhwhzx/zxxx'
        }else if(row.columnCode=='SYZT_ZHWHYJZX_YJZL'){
          this.patht='/yjdt/zhwhzx/yjzl'
        }else if(row.columnCode=='SYZT_ZHWHYJZX_ALK'){
          this.patht='/yjdt/zhwhzx/alk'
        }
      }
      localStorage.setItem('menuList', JSON.stringify(this.menuList));
      this.$router.push({
        path: '/wwnry',
        query: {
          title: row.value,
          time: row.time,
          id: row.id,
          // menuList:JSON.stringify(this.menuList),
          path: this.patht,
        },
      });
    },
    gotoLieBiao(path) {
      this.patht=path
      localStorage.setItem('menuList', JSON.stringify(this.menuList));
      if(path=='/yjdt/czdjsyjzx/zxgk'){
        if(this.tableData[0].columnCode=='SYZT_CZDJSYJZX_ZXXX'){
          this.patht='/yjdt/czdjsyjzx/zxxx'
        }else if(this.tableData[0].columnCode=='SYZT_CZDJSYJZX_CZDWX'){
          this.patht='/yjdt/czdjsyjzx/czdyjwx'
        }else if(this.tableData[0].columnCode=='SYZT_CZDJSYJZX_YJZL'){
          this.patht='/yjdt/czdjsyjzx/qtyjzl'
        }else if(this.tableData[0].columnCode=='SYZT_CZDJSYJZX_ALK'){
          this.patht='/yjdt/czdjsyjzx/alk'
        }else if(this.tableData[0].columnCode=='SYZT_FGYZJJZX_ZXXX'){
          this.patht='/yjdt/fgyzjjzx/zxxx'
        }else if(this.tableData[0].columnCode=='SYZT_FGYZJJZX_YJZL'){
          this.patht='/yjdt/fgyzjjzx/yjzl'
        }else if(this.tableData[0].columnCode=='SYZT_FGYZJJZX_ALK'){
          this.patht='/yjdt/fgyzjjzx/alk'
        }else if(this.tableData[0].columnCode=='SYZT_MZYZJYJZX_ZXXX'){
          this.patht='/yjdt/mzyzjzx/zxxx'
        }else if(this.tableData[0].columnCode=='SYZT_MZYZJYJZX_YJZL'){
          this.patht='/yjdt/mzyzjzx/yjzl'
        }else if(this.tableData[0].columnCode=='SYZT_MZYZJYJZX_ALK'){
          this.patht='/yjdt/mzyzjzx/alk'
        }else if(this.tableData[0].columnCode=='SYZT_ZHWHYJZX_ZXXX'){
          this.patht='/yjdt/zhwhzx/zxxx'
        }else if(this.tableData[0].columnCode=='SYZT_ZHWHYJZX_YJZL'){
          this.patht='/yjdt/zhwhzx/yjzl'
        }else if(this.tableData[0].columnCode=='SYZT_ZHWHYJZX_ALK'){
          this.patht='/yjdt/zhwhzx/alk'
        }
      }
      let self = this;
      this.$router.push({
        path: this.patht,
        query: {
          columnCode: this.tableData[0].columnCode,
          // menuList: JSON.stringify(self.menuList),
          path: this.patht,
        },
      });
    },
  },
};
</script>
<style>
.fd-news-right {
  width: 64%;
  height: 100%;
  cursor: pointer;
}

.fd-news-right h3 {
  width: 96%;
  margin: 2px 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
}

.fd-news-right div {
  width: 97%;
  height: 80px;
  font-size: 15px;
  line-height: 25px;
  margin: 8px 10px;
  color: rgb(163, 163, 163);
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: left;
  font-size: 14px;
}

.SYZT_JXPX_JXXX {
  width: 35%;
  height: 100%;
  object-fit: cover;
}

.SYZT_WHJL_ZHWH {
  width: 35%;
  height: 100%;
  object-fit: cover;
}

.SYZT_XWZX_YYXW {
  width: 35%;
  height: 100%;
  object-fit: cover;
}

.SYZT_XWZX_SYXW {
  width: 35%;
  height: 100%;
  object-fit: cover;
}

.rowClass {
  cursor: pointer;
  min-height: 144px;
}

.news-title {
  text-align: left;
  font-size: 20px;
  font-weight: 600;
  position: relative;
  box-sizing: border-box;
}

.fd-rowTiltle {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  width: 90%;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  float: left;
  color: #303133;
  font-size: 16px;
}

.tzyw {
  background: url('../assets/images/tzywTitle.png') no-repeat;
  background-size: 100% 100%;
}

.yyxw {
  background: url('../assets/images/byxwTitle.png') no-repeat;
  background-size: 100% 100%;
}

.syxw {
  background: url('../assets/images/byxwTitle.png') no-repeat;
  background-size: 100% 100%;
}

.sxsy {
  margin-top: -2px;
  background: url('../assets/images/sxsyTitle.png') no-repeat;
  background-size: 100% 100%;
}

.jxpx {
  background: url('../assets/images/jxpxTitle.png') no-repeat;
  background-size: 100% 100%;
}

.whjl {
  background: url('../assets/images/whjlTitle.png') no-repeat;
  background-size: 100% 100%;
}

.kyzk {
  background: url('../assets/images/kyzkTitle.png') no-repeat;
  background-size: 100% 100%;
}

.tzll {
  background: url('../assets/images/tzll.png') no-repeat;
  background-size: 100% 100%;
}

.tzgg {
  background: url('../assets/images/tzggTitle.png') no-repeat;
  background-size: 100% 100%;
}
.el-table__body-wrapper.is-scrolling-none{
  min-height: 144px;
  vertical-align: middle;
}

/* 为表格行添加最小高度 */
.el-table__row {
  min-height: 144px !important;
  height: auto !important;
}

/* .el-tooltip__popper {
  max-width: 30%;
  background-color: white !important;
  color: #606266 !important;
  border: 1px solid #606266 !important;
  border-radius: 0;
  padding:2px;
}
.el-tooltip__popper[x-placement^="top"] .popper__arrow {
  border-top-color: #606266 !important;
}
.el-tooltip__popper[x-placement^="top"] .popper__arrow:after {
  border-top-color: white !important;
} */
</style>



// WEBPACK FOOTER //
// src/components/news.vue